module.exports = __webpack_public_path__ + "img/icon_calendar_over.a67c6f43.svg";